import { mapState, mapGetters } from 'vuex';

import formatterMixin from './formatterMixin';

const partnerReviewMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      order: (state) => state.partnerReview.order,
      partnerSettings: (state) => state.partnerReview.partnerSettings,
      selectedPaymentMethod: (state) => state.partnerReview.selectedPaymentMethod,
      paymentMethods: (state) => state.partnerReview.paymentMethods,
      termsAccepted: (state) => state.partnerReview.termsAccepted,
      pdfFile: (state) => state.partnerReview.pdfFile,
      paymentPending: (state) => state.partnerReview.paymentPending,
      actionModalView: (state) => state.partnerReview.actionModalView,
      showActionModal: (state) => state.partnerReview.showActionModal,
      loadingOrder: (state) => state.partnerReview.loadingOrder,
      loadingPaymentMethod: (state) => state.partnerReview.loadingPaymentMethod,
      loadingAllPaymentMethods: (state) => state.partnerReview.loadingAllPaymentMethods,
      setupIntent: (state) => state.partnerReview.setupIntent,
      calculatingTax: (state) => state.partnerReview.calculatingTax,
      processingOrder: (state) => state.partnerReview.processingOrder,
      processingDirectDebit: (state) => state.partnerReview.processingDirectDebit,
      invoicePaymentMethod: (state) => state.partnerReview.invoicePaymentMethod,
    }),
    ...mapGetters([
      'statesOptions',
      'prTaxTotal',
      'prOrderTotal',
    ]),
  },
  methods: {
    changePartnerReviewValue(field, value) {
      this.$store.dispatch('changePartnerReviewValues', [{
        field,
        value,
      }]);
    },
    changePartnerReviewValues(changes) {
      this.$store.dispatch('changePartnerReviewValues', changes);
    },
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changePartnerReviewValues', [{
          field: 'showActionModal',
          value: false,
        }, {
          field: 'errorObj',
          value: {},
        }]);
      } else {
        this.$store.dispatch('changePartnerReviewValues', [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }]);
      }
    },
  },
};

export default partnerReviewMixin;
